import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { dataHooks } from './constants';
import compose from '../../hoc/compose';
import AddIcon from './AddItemIcon';
import _Symbol from '../symbol/symbol';
import TextLabel from '../textLabel/textLabel';
var ADD_MODES = {
  SINGLE: 'single',
  MULTIPLE: 'multi',
  ALREADY_ADDED: 'added'
};
var AddableListItem = /*#__PURE__*/function (_React$Component) {
  function AddableListItem() {
    var _this;
    _classCallCheck(this, AddableListItem);
    _this = _callSuper(this, AddableListItem);
    _this.handleClick = function () {
      var disabled = _this.props.disabled;
      var afterClick = _this.state.afterClick;
      if (disabled || afterClick || _this.alreadyAddedMode()) {
        return;
      }
      if (_this.singleMode()) {
        _this.setState({
          afterClick: true
        });
      }
      _this.props.onClick();
    };
    _this.getIconClassName = function () {
      var inProgress = _this.props.inProgress;
      var afterClick = _this.state.afterClick;
      if (inProgress) {
        return 'in-progress';
      }
      var alreadyAdded = afterClick && _this.singleMode() || _this.alreadyAddedMode();
      if (alreadyAdded) {
        return 'added';
      }
      return _this.state.afterClick ? 'added' : 'default';
    };
    _this.singleMode = function () {
      return _this.props.addMode === ADD_MODES.SINGLE;
    };
    _this.alreadyAddedMode = function () {
      return _this.props.addMode === ADD_MODES.ALREADY_ADDED;
    };
    _this.getItemStyle = function () {
      return _this.singleMode() ? {
        transitionDuration: _this.props.fadeOutDuration
      } : {};
    };
    _this.getTextWidth = function () {
      return "calc(100% - ".concat(!_.isEmpty(_this.props.contentBefore) * 96 + !_.isEmpty(_this.props.contentAfter) * 24, "px)");
    };
    _this.getItemClasses = function () {
      var _this$props = _this.props,
        getClassName = _this$props.getClassName,
        disabled = _this$props.disabled,
        inProgress = _this$props.inProgress,
        disableFadeOut = _this$props.disableFadeOut;
      var afterClick = _this.state.afterClick;
      var classNames = [];
      classNames.push(getClassName('control-addable-list-item'));
      if (disabled) {
        classNames.push('disabled');
      }
      var shouldFadeOut = !disableFadeOut && afterClick && _this.singleMode() && !inProgress;
      if (shouldFadeOut) {
        classNames.push('after-click');
      }
      return classNames.join(' ');
    };
    _this.state = {
      afterClick: false
    };
    return _this;
  }
  _inherits(AddableListItem, _React$Component);
  return _createClass(AddableListItem, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.getItemClasses(),
        onClick: this.props.disabled ? null : this.handleClick,
        style: this.getItemStyle()
      }, this.props.contentBefore ? /*#__PURE__*/React.createElement("div", {
        key: "contentBefore",
        "data-aid": "content-before",
        className: "list-item-content-before"
      }, this.props.contentBefore) : null, /*#__PURE__*/React.createElement("div", {
        className: "list-item-content",
        style: {
          width: this.getTextWidth()
        }
      }, /*#__PURE__*/React.createElement(TextLabel, {
        className: "list-item-label",
        dataHook: dataHooks.title,
        type: "T01",
        value: this.props.label,
        shouldTranslate: this.props.shouldTranslate,
        automationId: "text-label"
      }), this.props.description ? /*#__PURE__*/React.createElement(TextLabel, {
        dataHook: dataHooks.subtitle,
        automationId: "text-description",
        type: "T17",
        key: "description",
        value: this.props.description,
        shouldTranslate: this.props.shouldTranslate,
        className: 'list-item-description' + (this.props.disabled ? ' disabled' : '')
      }) : null), this.props.contentAfter ? /*#__PURE__*/React.createElement("div", {
        key: "contentAfter",
        "data-aid": "content-after",
        className: "list-item-content-after"
      }, this.props.contentAfter) : null, /*#__PURE__*/React.createElement(_Symbol, {
        "data-aid": "add-item-icon",
        className: 'add-item-icon ' + this.getIconClassName() + (this.props.disabled ? ' disabled' : '')
      }, /*#__PURE__*/React.createElement(AddIcon, null)));
    }
  }]);
}(React.Component);
AddableListItem.displayName = 'AddableListItem';
AddableListItem.propTypes = {
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** A callback function to be triggered when the item is added */
  onClick: PropTypes.func.isRequired,
  /** The main title for the item */
  label: PropTypes.string.isRequired,
  /** When provided, a subtitle will be added to the item with this text*/
  description: PropTypes.string,
  /** Set a disabled behaviour on the component */
  disabled: PropTypes.bool,
  /** The duration of the item fadeout after the item was added.
   * Accepts any non-negative CSS time value, such as `0.5s` or `500ms`.
   * @linkTypeTo https://developer.mozilla.org/en-US/docs/Web/CSS/time
   * @setTypeName time
   */
  fadeOutDuration: PropTypes.string,
  /** Prevents clicking on an item right after it was clicked (for example while it is fading out) */
  inProgress: PropTypes.bool,
  /** Weather or not the item should be faded out after was added */
  disableFadeOut: PropTypes.bool,
  /** A slot to be renderer before the item label */
  contentBefore: PropTypes.element,
  /** A slot to be renderer after the item label */
  contentAfter: PropTypes.element,
  /** Set the mode of the item to be displayed properly. For `Single` the item is displayed as a new one. For `Added` the item is displayed as it was added already. `Multi` is not supported and behaves like `Single`. */
  addMode: PropTypes.oneOf([ADD_MODES.SINGLE, ADD_MODES.MULTIPLE, ADD_MODES.ALREADY_ADDED])
};
AddableListItem.defaultProps = {
  disabled: false,
  fadeOutDuration: '0.8s',
  inProgress: false,
  disableFadeOut: false,
  addMode: ADD_MODES.SINGLE
};
export default compose(AddableListItem);